import type { EntityStatus, FeatureAccessInsights, YammerState } from '../../state/types';
import { getStatus } from '../../state/types';

type GetFeatureAccessInsights = (state: YammerState) => FeatureAccessInsights | undefined;
export const getFeatureAccessInsights: GetFeatureAccessInsights = (state: YammerState) =>
  state.featureAccessInsights.fulfilled;

type GetFeatureAccessInsightsStatus = (state: YammerState) => EntityStatus;
export const getFeatureAccessInsightsStatus: GetFeatureAccessInsightsStatus = (state) =>
  getStatus(state.featureAccessInsights);
